import DownloadAppStoreLink from './DownloadAppStoreLink';
import DownloadPlayStoreLink from './DownloadPlayStoreLink';

const DownloadAppLinks = ({ compact = false }) => {
    return (
        <div style={{ margin: compact ? '24px 0px 0px' : '80px 20px', textAlign: 'center' }}>
            <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
                <DownloadAppStoreLink />
                <DownloadPlayStoreLink />
            </div>
        </div>
    );
};

export default DownloadAppLinks;
